const translations = {
  'paymentPlan.seo.title': 'Plan de pago del curso TEFL España',
  'paymentPlan.seo.description':
    'Conoce nuestro plan de pago flexible para nuestros cursos TEFL en Barcelona y Sevilla. Nuestro objetivo es ser abiertos y accesibles a todos los presupuestos. ',
  'paymentPlan.main.title': 'Plan de Pagos Para tu Curso TEFL',
  'paymentPlan.sec1.title': '¿Cómo puedo pagar?',
  'paymentPlan.sec1.description':
    'Una vez se haya confirmado tu lugar en el curso, te enviaremos un enlace de pago sencillo donde podrás ingresar los detalles de tu tarjeta de crédito o débito. Si prefieres hacer una transferencia bancaria, te proporcionaremos los detalles necesarios.',
  'paymentPlan.sec1.bot.title': '¡Pago en Plazos!',
  'paymentPlan.sec1.bot.description':
    'Entendemos que estos cursos requieren una gran inversión y queremos hacerlos accesibles para tantas personas como sea posible. Por lo tanto, ofrecemos el siguiente plan de pagos:',
  'paymentPlan.sec1.ben1.title': 'Primer Pago',
  'paymentPlan.sec1.ben1.text': 'Una vez seas admitido al curso',
  'paymentPlan.sec1.ben2.title': 'Primer pago',
  'paymentPlan.sec1.ben2.text': 'Un mes después del primer pago',
  'paymentPlan.sec1.ben3.title': 'Último pago',
  'paymentPlan.sec1.ben3.text': 'Un mes antes de tu cita en la embajada',
  'paymentPlan.sec1.bot.text':
    'Ten en cuenta que el plan de pagos solo está disponible en los precios completos. Si deseas aprovechar la tarifa de descuento por inscripción anticipada, debes pagar el saldo completo al momento de registrarte.',
  'paymentPlan.sec2.title': 'TEFL y visa de estudiante',
  'paymentPlan.sec2.description':
    ' Ofrecemos un plan de pagos similar en el que puedes pagar en cuotas, pero ten en cuenta que tus tasas de curso deben pagarse en su totalidad al menos 2 semanas antes de cualquier cita en el consulado. Esto nos permite un tiempo suficiente para preparar y enviar documentos. El Ministerio de Asuntos Exteriores de España requiere que todas las tasas de curso estén pagadas en su totalidad antes de procesar cualquier visa de estudiante.',
  'paymentPlan.sec2.conditions': 'TÉRMINOS Y CONDICIONES DE PAGO',
  'paymentPlan.sec2.condText':
    'Por favor, tómate un momento para leer los <accentedLink>términos y condiciones de pago</accentedLink>',
};

export default translations;
